import { AppConfig } from "~/AppConfig";

/**
 * Sets the WS-authentication cookie for ActionCable.
 * Called before page reloads (impersonation) and on reconnect attempts
 * to ensure the cable connection authenticates as the correct user.
 */
export async function setWsCookie(token: string): Promise<void> {
  await fetch(`${AppConfig.API_URL}/api/ui/v1/session/cookie`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
      Accept: "application/json",
    },
  });
}
